import {useTranslation} from '@aboutyou/i18n';
import {Button, COLORS, GenericIconName, Icon} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {
  SoldOutComponentProps,
  StyledProductSelectionGrid,
} from '../ProductSelectionView';
import {SimilarProductsReco} from './SimilarProductReco';

export const SoldOutStateWithReco: React.FC<
  SoldOutComponentProps & {
    renderingPriority?: number;
  }
> = ({
  colorOptions,
  onSoldOutButtonClick,
  ColorOptionsComponent,
  renderingPriority,
}) => {
  const {t} = useTranslation();

  return (
    <>
      <div>
        <ButtonWrapper>
          <ReminderButton
            data-testid="sizeReminderButton"
            onClick={() => onSoldOutButtonClick?.()}
            aria-label={undefined}
          >
            <Icon fill={COLORS.White} asset={GenericIconName.Mail} size="S" />
            {t('Remind me when this is available')}
          </ReminderButton>
        </ButtonWrapper>
      </div>
      {colorOptions && <ColorOptions>{ColorOptionsComponent}</ColorOptions>}

      <SimilarProductsReco renderingPriority={renderingPriority} />
    </>
  );
};

const ReminderButton = styled(Button)`
  gap: 0.25rem;
`;

const ButtonWrapper = styled.div`
  padding: 0.5rem 1rem 0.375rem 1rem;
`;

const ColorOptions = styled.div`
  padding: 0 1rem 1rem;
  text-align: center;
  ${StyledProductSelectionGrid} {
    margin: 0;
  }
`;
